import React from "react";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import { Helmet } from "react-helmet";
import Introduction1 from "../src/images/AboutUSDB.png";
import "./App.css";
import youroffer1 from "../src/images/4.jpg";
import youroffer2 from "../src/images/3.jpg";
import youroffer3 from "../src/images/2.jpg";
import youroffer4 from "../src/images/1.jpg";
import { Card } from "primereact/card";

function About () {

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>About | Clota Technology</title>
        <meta
          name="description"
          content="Clota Technology - One-stop solution for all database updates including MySQL, PostgreSQL, and Oracle. Learn more about our mission."
        />
        <meta
          name="keywords"
          content="About Clota, Database Updates, MySQL, PostgreSQL, Oracle, Version Fixes, Security Patches"
        />
        <meta name="author" content="Clota Technology" />
      </Helmet>

            <div className="banner-container">
              <img src={Introduction1} className="banner-image" alt="Banner" />
      
              {/* Centered Content */}
              <div className="banner-content fs-h1">
                <div className="banner-text">
                  <h1 className="banner-heading">About Us </h1>
                  {/* <p>Apply Now!</p> */}
                </div>
              </div>
            </div>

                  {/* About Text */}
      <div className="mt-5 px-5 py-2">
        <div className="flex flex-column align-items-start">
                           <h3 className="fs-h3">
                    Introducing the One-Stop Database Update Site
                  </h3>
                  <p className="fs-p">
                    Are you tired of scouring the internet for information on
                    the latest version updates, security updates, and bug fixes
                    for your databases? Look no further! Our website is here to
                    provide all of the information you need in one convenient
                    location.
                    <br />
                    <br />
                    We understand the importance of keeping your databases up to
                    date. Not only do updates fix known issues and improve
                    performance, but they also keep your databases secure and
                    protect against vulnerabilities. That's why we've created a
                    website that makes it easy to find the information all you
                    need. Our website is a one-stop resource for information on
                    version updates, security updates, and bug fixes for popular
                    databases such as MySQL, PostgreSQL, and Oracle. We provide
                    release notes, download links, and instructions on how to
                    apply the updates, all in one place. Don't waste any more
                    time searching for database update information. Visit our
                    site today and stay up to date with the latest and greatest.
                  </p>
        </div>
      </div>


       
        <h3 className="fs-h2 text-center" style={{ fontFamily: "rockwell" }}>
<b>Our Products</b>
        </h3>
 

<div className="grid px-5 mb-5 d-flex justify-content-center align-items-center">
  {/* Web Development Card */}
  <div className="col-12 md:col-6 lg:col-3">
    <Card className="h-full shadow-2 border-round surface-card card-flex-offering">
      <div className="text-center">
        <img
          src={youroffer1}
          alt="HelloEMS"
          className="mb-3"
          style={{
            width: "100%",
            height: "200px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
      </div>
      <div className="p-2 text-center card-offer-content">
        <h3 className="fs-h3">Hello Ems</h3>
        <p style={{ fontSize: "14px" , marginBottom:"75px"}}>
 A creative digital agency crafting stunning websites and smart solutions that elevate your online presence.
        </p>

        <div className="card-footer-offering">
          <Link to="https://helloems.com/" onClick={scrollToTop}>
            <Button
              label="Visit Us"
              className="btn-styles fontclass"
              // severity="info"
            />
          </Link>
        </div>
      </div>
    </Card>
  </div>

  {/* Cloud Services Card */}
  {/* <div className="col-12 md:col-6 lg:col-3">
    <Card className="h-full shadow-2 border-round surface-card card-flex-offering">
      <div className="text-center">
        <img
          src={youroffer3}
          alt="ClotaTech"
          className="mb-3"
          style={{
            width: "100%",
            height: "200px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
      </div>
      <div className="p-2 text-center card-offer-content">
        <h3 className="fs-h3">AV-CS</h3>
        <p style={{ fontSize: "14px" , marginBottom:"75px"}}>
At Av‑CS, we help businesses grow by offering expert HR solutions, dynamic coaching programs, and impactful support for the education sector—designed to bring out the best in people and teams.

        </p>

        <div className="card-footer-offering">
          <Link to="https://av-cs.in/" onClick={scrollToTop}>
            <Button
              label="Visit Us"
              className="btn-styles fontclass"
              // severity="info"
            />
          </Link>
        </div>
      </div>
    </Card>
  </div> */}

  {/* Database Services Card */}
  <div className="col-12 md:col-6 lg:col-3">
    <Card className="h-full shadow-2 border-round surface-card card-flex-offering">
      <div className="text-center">
        <img
          src={youroffer2}
          alt="911DBA"
          className="mb-3"
          style={{
            width: "100%",
            height: "200px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
      </div>
      <div className="p-2 text-center card-offer-content">
        <h3 className="fs-h3">911 DBA</h3>
        <p style={{ fontSize: "14px" , marginBottom:"75px"}}>
  Our expert DBAs provide round-the-clock database support, performance tuning, and secure architecture solutions.
        </p>

        <div className="card-footer-offering">
          <Link to="https://911dba.com/" onClick={scrollToTop}>
            <Button
              label="Visit Us"
              className="btn-styles fontclass"
              // severity="info"
            />
          </Link>
        </div>
      </div>
    </Card>
  </div>

  {/* Additional Services Card */}
  {/* <div className="col-12 md:col-6 lg:col-3">
    <Card className="h-full shadow-2 border-round surface-card card-flex-offering">
      <div className="text-center">
        <img
          src={youroffer4}
          alt="kidschoice"
          className="mb-3"
          style={{
            width: "100%",
            height: "200px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
      </div>
      <div className="p-2 text-center card-offer-content">
        <h3 className="fs-h3">Kids Choice</h3>
        <p style={{ fontSize: "14px" , marginBottom:"75px" }}>
          Engaging, educational, and fun digital services designed especially for young minds and family-focused experiences.
        </p>

        <div className="card-footer-offering">
          <Link to="https://kidschoice.co.in/" onClick={scrollToTop}>
            <Button
              label="Visit Us"
              
              className="btn-styles fontclass"
              
              // severity="info"
            />
          </Link>
        </div>
      </div>
    </Card>
  </div> */}
</div>      

      {/* <section id="aboutpage" className="flex align-items-center">
        <div className="p-fluid">
          <div className="grid">
            <div className="col-12 md:col-10 md:mx-auto">
              <div className="grid">
                <div className="col-12 flex flex-column justify-content-center text-center">
                 
                  <h3 className="fs-h3">
                    Introducing the One-Stop Database Update Site
                  </h3>
                  <p className="fs-p">
                    Are you tired of scouring the internet for information on
                    the latest version updates, security updates, and bug fixes
                    for your databases? Look no further! Our website is here to
                    provide all of the information you need in one convenient
                    location.
                    <br />
                    <br />
                    We understand the importance of keeping your databases up to
                    date. Not only do updates fix known issues and improve
                    performance, but they also keep your databases secure and
                    protect against vulnerabilities. That's why we've created a
                    website that makes it easy to find the information all you
                    need. Our website is a one-stop resource for information on
                    version updates, security updates, and bug fixes for popular
                    databases such as MySQL, PostgreSQL, and Oracle. We provide
                    release notes, download links, and instructions on how to
                    apply the updates, all in one place. Don't waste any more
                    time searching for database update information. Visit our
                    site today and stay up to date with the latest and greatest.
                  </p>
                  <hr className="custom-hr" />
                  <h3 className="fs-h3">Get Started Now</h3>
                  <div className="flex justify-content-center">
                    <Link
                      to="/"
                      className="inline-flex text-decoration-none"
                      style={{ textDecoration: "none" }}
                      onClick={() => {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}>
                      <Button
                        label="Click Here"
                        // icon="pi pi-arrow-right"
                        className="p-button-rounded p-button-info"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default About;
